import { createRequestHelper } from '@utils/swr'
import { type WpUserIsRegisteredRequest } from '../types/apiRequest'
import { type isUserRegisteredResponse } from '../types/apiResponse'
import { type WpApis } from '../types/apis'

const {
  useRequest,
} = createRequestHelper<WpApis['get']['checkIsUserRegistered'], isUserRegisteredResponse, WpUserIsRegisteredRequest>({
  client: 'wpRelay',
  key: (params) => {
    const { identifier, login_type } = params || {}
    if (!identifier) return null
    if (!login_type) return null
    return `/dni/mu/user/registered?login_type=${login_type}&identifier=${identifier}`
  },
})

export const useApiIsUserRegistered = useRequest
